<template>
  <a href="https://online2025.worldaic.com.cn/home?channelSource=Web" class="yunpingtai" :style="{ left: list[activeIndex % 4].left, top: list[activeIndex % 4].top }">
    <!-- <img :src="'https://static.worldaic.com.cn/2024/web/static/images/yunpingtai2-en.png' + randomtag" v-if="En" alt="">
    <img :src="'https://static.worldaic.com.cn/2024/web/static/images/yunpingtai2.png' + randomtag" v-else alt=""> -->
    <img src="@/assets/images/云平台-en.png" v-if="En" alt="">
    <img src="@/assets/images/云平台.png" v-else alt="">
  </a>
</template>

<script>
export default {
  name: 'yunpingtai',
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          left: `calc(100vw - 2.22rem)`,
          top: `50%`
        },
        {
          left: `50%`,
          top: `calc(100vh - 1.52rem)`
        },
        {
          left: 0,
          top: `50%`
        },
        {
          left: `50%`,
          top: 0
        },
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.activeIndex++
      setInterval(() => {
        this.activeIndex++
      }, 10000)
    })
  }
}
</script>

<style lang="less" scoped>
  .yunpingtai {
    position: fixed;
    width: 2.22rem;
    z-index: 97;
    transition: 10s linear;
    cursor: pointer;
    img {
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/yunpingtai.vue